import * as types from './mutation-types.js'
import analytics from '@/services/api/analytics.js'
import { getAnalyticsOptions } from '../../helpers'

// initial state
const state = () => ({
  'applications': [],
  'web_players': [],
  'operating_systems': [],
  'browsers': [],
  'network_types': [],
  'providers': [],
  'device_class': [],
  'devices': [],

  'applications_total': 0,
  'web_players_total': 0,
  'operating_systems_total': 0,
  'browsers_total': 0,
  'network_types_total': 0,
  'providers_total': 0,
  'device_class_total': 0,
  'devices_total': 0
})

// getters
const getters = {

}

// actions
const actions = {
  async getTechnologyByType ({ commit, rootState, rootGetters }, { type, compare }) {
    commit(types.CLEAR_TECH_BY_TYPE, type)
    commit(types.CLEAR_TECH_TOTAL_BY_TYPE, type)
    let options = getAnalyticsOptions(rootState, rootGetters, compare)
    options.type = type
    await analytics.getTech(options).then((data) => {
      let apiCalls = []
      apiCalls[type] = {
        href: data.href,
        time: new Date().toUTCString()
      }
      commit('ADD_API_CALLS', apiCalls, { root: true })
      commit(types.SET_TECH_BY_TYPE, { type, results: data.collection })
      commit(types.SET_TECH_TOTAL_BY_TYPE, { type, total: data.total })
    })
  }
}

// mutations
const mutations = {
  [types.CLEAR_TECH_BY_TYPE] (state, type) {
    state[type] = []
  },
  [types.CLEAR_TECH_TOTAL_BY_TYPE] (state, type) {
    state[`${type}_total`] = 0
  },
  [types.SET_TECH_BY_TYPE] (state, { type, results }) {
    state[type] = results
  },
  [types.SET_TECH_TOTAL_BY_TYPE] (state, { type, total }) {
    state[`${type}_total`] = total
  }
}

export default {
  namespace: true,
  state,
  actions,
  mutations,
  getters
}
